import { useScript } from '@ccg/core';
import React$1, { useEffect } from 'react';
import PropTypes$1 from 'prop-types';
import StyledSocialFeed from './SocialFeed.styles.js';

const SocialFeed = ({
  feedType,
  feedId
}) => {
  const status = useScript('//cdn.curator.io/3.1/js/curator.js');
  useEffect(() => {
    if (status === 'ready') {
      if (!document.getElementById('curator-css')) {
        const styles = document.createElement('link');
        styles.rel = 'stylesheet';
        styles.id = 'curator-css';
        styles.type = 'text/css';
        styles.media = 'screen';
        styles.href = '//cdn.curator.io/3.1/css/curator.css';
        document.getElementsByTagName('head')[0].appendChild(styles);
      }

      const widget = window.Curator.loadWidget({
        container: '#curator-feed',
        type: feedType,
        feedId
      });
      return () => widget.destroy();
    }
  }, [status]);
  return /*#__PURE__*/React$1.createElement(StyledSocialFeed, null, /*#__PURE__*/React$1.createElement("div", {
    id: "curator-feed"
  }, /*#__PURE__*/React$1.createElement("a", {
    href: "https://curator.io",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "crt-logo"
  }, "Powered by Curator.io")));
};

SocialFeed.propTypes = {
  feedType: PropTypes$1.string.isRequired,
  feedId: PropTypes$1.string.isRequired
};

export default SocialFeed;
